import Slider from "./Slider.js"
import Utils from "./Utils.js"

export default class Volume extends Slider {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-volume", true)
    this.state.min = 0
    this.state.max = 100
    this.state.percent = this.player.volume
    this.state.value = this.player.volume * 100
    this.state.altText = "MSG_VOLUME"
    this._open = true
    this.timeout = null
    if (this.config.volume) {
      this.direction = this.config.volume.direction ? this.config.volume.direction : ""
      if (this.direction === "vertical") {
        this.classList.add("amp-volume-"+this.direction, true)
        this.classList.add("amp-slider-"+this.direction, true)
        this.classList.remove("amp-slider", true)
      }
    }
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onready(event) {
    this.open = this.direction !== "vertical"
    this.classList.update({"amp-open": this._open})
  }

  onseeked(event) {
    this.open = false
  }

  onmediachange(event) {
    this.open = false
  }

  set open(value) {
    if(this.direction == "vertical") {
      this._open = value;
      this.classList.update({"amp-open": this._open})
    }
  }

  format(value) {
    return Math.round(value)
  }

  onvolumechange(event) {
    this.update({percent: event.detail})
  }

  onClick(event) {
    this.move(event)
  }

  onChange(value) {
    this.player.volume = value.percent
  }

  onMouseOver(event) {
    this.plugin.dispatchEvent(new akamai.amp.Event("volumemouseover"))
    this.open = true
    clearTimeout(this.timeout)
  }

   onMouseOut(event) {
     this.plugin.dispatchEvent(new akamai.amp.Event("volumemouseout"))
     clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.open = false
    }, 350)
  }

  onHandleMouseDown(event) {
    event.stopPropagation()
    event.preventDefault()
    this.dragging = true
    window.addEventListener("mouseup", this.onHandleMouseUp)
    window.addEventListener("mousemove", this.onHandleMouseMove)
    window.addEventListener("touchend", this.onHandleMouseUp)
    window.addEventListener("touchmove", this.onHandleMouseMove)
  }

  render() {
    if (akamai.amp.Utils.isVolumeSettable() == false)
      return null

    super.render()

    const percent = `${Utils.round(this.percent * 100, 2)}%`
    const range = `${Utils.round(this.range * 100, 2)}%`
    const vertical = (this.direction == "vertical")
    const style = (vertical) ? {bottom: percent} : {left: percent}

    return (
      <div ref="element" {...this.propsList} onMouseMove={this.onMouseMove}>
        {vertical && <div ref="panel" className="amp-volume-panel"></div>}
        <div ref="track" className="amp-track"></div>
        <div ref="range" className="amp-range" style={{width: range}}></div>
        <div ref="value" className="amp-value" style={{width: percent}}></div>
        {this.children}
        <div ref="handle" className="amp-handle" style={style} onMouseDown={this.onHandleMouseDown} onTouchStart={this.onHandleMouseDown}></div>
      </div>
    )
  }
}
